import { useNotificationsContext } from "common/context/NotificationsProvider"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import NotificationsMenuNoData from "./NotificationsMenuNoData"

import "../style.scss"

const NotificationsMenuAllRead = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'seeAllNotifications' does not exist on t...
  const { seeAllNotifications } = useNotificationsContext()

  return (
    <div className='notifications-menu-all-read tw-flex tw-flex-col tw-justify-center tw-items-center !tw-w-[100vw] md:!tw-w-[600px]'>
      <NotificationsMenuNoData />
      <div className='notifications-menu-all-read-message'>
        {t("notificationsMenu.msgNoNotification")}
      </div>
      <Button
        className='p-button-text notifications-menu-all-read-button flex-column justify-content-center'
        onClick={seeAllNotifications}
      >
        {t("notificationsMenu.showAllNotification")}
      </Button>
    </div>
  )
}

export default NotificationsMenuAllRead
